<a class="primary p-0" data-original-title="" title="" (click)="viewRoute()">
    <i class="ft-image font-medium-1 mr-2"></i>
</a>